import { useEffect, useState } from "react";

// PayPal's SDK and Stripe.js are only needed where people pay: the checkout,
// payment links (make-payment) and the billing tab of Settings. Until 2026-09
// both were loaded on every page, the home included, one of them
// render-blocking in the <head>. Now they start loading as soon as one of
// those screens is opened (the checkout's first step already does it, so the
// payment step finds them ready), or right away when the visitor lands on one.
const PAYMENT_AREAS = /^\/(order(\/|$)|make-payment\/|account\/settings)/;

const STRIPE_JS = "https://js.stripe.com/basil/stripe.js";

// The same tag the page used to carry in its <head>, added on demand.
// @stripe/stripe-js (imported from "/pure", which loads nothing by itself)
// finds it and waits for it instead of adding a second one.
const loadStripeScript = () => {
  if (window.Stripe || document.querySelector('script[src^="https://js.stripe.com/"]')) return;
  const script = document.createElement("script");
  script.src = STRIPE_JS;
  script.async = true;
  document.head.appendChild(script);
};

let payPalWanted = false;
const listeners = new Set();

// Called when a payment screen is opened (or about to be).
export const wantPaymentScripts = () => {
  loadStripeScript();
  if (payPalWanted) return;
  payPalWanted = true;
  listeners.forEach((listener) => listener());
};

if (PAYMENT_AREAS.test(window.location.pathname)) {
  wantPaymentScripts();
}

// For PayPalScriptProvider's deferLoading: false once PayPal is needed.
export const usePayPalWanted = () => {
  const [wanted, setWanted] = useState(payPalWanted);
  useEffect(() => {
    if (payPalWanted) {
      setWanted(true);
      return undefined;
    }
    const listener = () => setWanted(true);
    listeners.add(listener);
    return () => listeners.delete(listener);
  }, []);
  return wanted;
};
